module.exports = __webpack_public_path__ + "img/industrialMechanics_sign.99f27c4d.png";